import * as UAParser from 'ua-parser-js';

export class UserAgentInfo {
    ua: string | null;

    constructor(ua: string | null) {
        this.ua = ua;
    }

    private getResult(): UAParser.IResult {
        const parser = new UAParser.UAParser();
        if (this.ua) {
            parser.setUA(this.ua);
        }
        return parser.getResult();
    }

    get browserName(): string | undefined {
        return this.getResult().browser.name;
    }

    get osName(): string | undefined {
        return this.getResult().os.name;
    }

    // detect known android stock browser versions which need a fix for absolute positioning
    get isProblematicAndroidStockBrowser(): boolean {
        const problematicVersions = ['535.19'];

        // to detect an old problematic android stock browser, we look at the webkit version
        // in general, the android stock browser, Chrome, Safari and Opera use the user agent "webkit" property

        const uapRes = this.getResult();

        // if the ua claims not to be an Android device, this is no old stock browser
        if (uapRes.os.name !== 'Android') {
            return false;
        }

        // if it is an Opera browser, it is no old stock browser
        if (uapRes.browser.name === 'Opera') {
            return false;
        }

        if (uapRes.engine.name === 'WebKit') {
            const webkitV = uapRes.engine.version
                ? parseFloat(uapRes.engine.version)
                : null;
            if (webkitV) {
                for (let i = 0; i < problematicVersions.length; i++) {
                    if (problematicVersions[i] === uapRes.engine.version) {
                        return true;
                    }
                }
                return false;
            }
        }

        return false;
    }
}
